export default "__VITE_PUBLIC_ASSET__53235516__"